
<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
            <h1 class="modal-title fs-5" id="addOrderLabel">Order Image</h1>
            <a type="button" data-bs-dismiss="modal">
                <i class="h5 fi fi-rr-circle-xmark"></i>
            </a>
        </div>
        <div class="modal-body text-center">

            @if (imgIsWebUploaded) {
                <div class="d-flex justify-content-end mb-3">
                    <button (click)="DeleteOrderPictures()" class="btn btn-primary">
                        <i class="me-1 fi fi-rr-trash-xmark"></i>
                        Remove
                    </button>
                </div>
            }

            <img [src]="img" class="img-fluid">

        </div>

    </div>
</div>


<app-custom-toast></app-custom-toast>